import * as types from './actionTypes';
import client from 'helpers/client';
import cognito from 'helpers/cognito';

export const getOrderHistory = (limit, page) => {
  return async (dispatch) => {
    dispatch({ type: types.GET_ORDER_HISTORY });
    client
      .api(`/order/user-get-order-history?limit=${limit}&page=${page}`, 'get', {
        headers: await cognito.getHeaderAuthorization(),
      })
      .then(({ data }) => {
        dispatch({
          type: types.GET_ORDER_HISTORY_SUCCESS,
          data: { history: data.data, pagination: data.pagination },
        });
      })
      .catch((err) => {
        dispatch({
          type: types.GET_ORDER_HISTORY_FAILED,
          reason: err,
        });
      });
  };
};
